<template>
  <section class="section">
    <div class="container">
      <div class="section-head" v-reveal>
        <span class="section-eyebrow">FEATURED CASES</span>
        <h2 class="section-title">精选<em>成功案例</em></h2>
        <p class="section-sub">每一个项目都是一次值得信赖的交付，点击查看案例背后的解决方案。</p>
      </div>

      <div class="case-grid">
        <CaseCard
          v-for="(c, i) in featured"
          :key="c.id"
          :item="c"
          v-reveal="{ delay: i * 120 }"
        />
      </div>

      <div class="center-link" v-reveal>
        <router-link to="/cases" class="btn btn-blue-outline">查看全部案例</router-link>
      </div>
    </div>
  </section>
</template>

<script setup>
import cases from '@/data/cases'
import CaseCard from '@/components/CaseCard.vue'

const featured = cases.slice(0, 3)
</script>

<style scoped>
.case-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
}

.center-link {
  margin-top: 44px;
  text-align: center;
}

@media (max-width: 992px) {
  .case-grid {
    grid-template-columns: 1fr;
    max-width: 560px;
    margin: 0 auto;
  }
}
</style>
